import ArtistVerifiedIcon from '@/shared-components/icons/components/user-profile/ArtistVerifiedIcon';

import ArtistImage from './ArtistImage';

import './styles/ArtistAdminCard.css';

export default function ArtistAdminCard({ artistData, children }) {
  // Ahora el backend ya te envía `imageId`
  const imageId = artistData.imageId;
  const roadCompleted = artistData.roadCompleted|| false;
  const hasImage = Boolean(imageId);

  return (
    <div className={`artist-admin-card__container ${hasImage ? '' : 'no-image'}`}>
      <div className="artist-admin-card__image-column">
        {hasImage && (
        
          <ArtistImage
            image={imageId}
            imageClassName="artist-admin-card__image"
          />
        )}
      </div>

      <div className="artist-admin-card__info-column">
        <div className="artist-admin-card__row artist-admin-card__row--header">
          <span className="artist-admin-card__name">
            {artistData.artist_name}
            {roadCompleted && (
              <ArtistVerifiedIcon className="artwork-view-thought__artist-verified-icon" />
            )}
          </span>
          
        </div>
        <div className="artist-admin-card__row artist-admin-card__row--details">
          <span className="artist-admin-card__meta">
            {artistData.artist_nationality || 'Sin país asignado'},{' '}
            {artistData.artist_birth || '–'}
          </span>
        </div>
      </div>

      <div className="artist-admin-card__actions-column">
        {children}
      </div>
    </div>
  );
}
